module.exports = __webpack_public_path__ + "img/bg-fwzl.499d504b.png";